import clsx from 'clsx'
import { createFileRoute } from '@tanstack/react-router'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'

import $type from '@tandem/ui/type.css'
import Spinner from '@tandem/ui/Spinner'
import $table from '@tandem/ui/table.css'

import { useTRPC, type RouterOutputs } from '@/trpc'
import TrashIcon from '@tandem/ui/icons/trash.svg?react'
import $anim from '@tandem/ui/anim.css'

import $ from './-styles.css'

export const Route = createFileRoute('/suppliers/')({
  component: SuppliersPage
})

type SupplierSummary = RouterOutputs['supplier']['list'][number]

function SuppliersPage() {
  let trpc = useTRPC()
  let { data: suppliers = [], isFetching } = useQuery(trpc.supplier.list.queryOptions())

  return (
    <div class={$.container}>
      {suppliers.length > 0 ?
        <table
          class={clsx('unstyled', $table.table, {
            [$anim.loadingOverlay]: isFetching
          })}
        >
          <thead>
            <tr>
              <th>Бренд</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {suppliers.map((supplier) => (
              <SupplierRow key={supplier.id} supplier={supplier} />
            ))}
          </tbody>
        </table>
      : <p class={$type.muted}>
          {isFetching ? <Spinner /> : 'Нет поставщиков.'}
        </p>
      }
    </div>
  )
}

function SupplierRow({ supplier }: { supplier: SupplierSummary }) {
  let trpc = useTRPC()
  let queryClient = useQueryClient()
  let deletion = useMutation({
    ...trpc.supplier.delete.mutationOptions({
      onSuccess() {
        queryClient.invalidateQueries(trpc.supplier.list.queryOptions())
      }
    })
  })

  return (
    <tr>
      <td>{supplier.brand?.name ?? '—'}</td>
      <td>
        <button
          class={clsx('plain', $type.muted)}
          onClick={() => {
            if (confirm('Удалить?')) {
              deletion.mutate({ id: supplier.id })
            }
          }}
          disabled={deletion.isPending}
        >
          {deletion.isPending ? <Spinner /> : <TrashIcon />}
        </button>
      </td>
    </tr>
  )
}
